import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href="/#home">Home</a>
        </li>
        <li>
          <a href="/#contact">Contact &amp; Support</a>
        </li>
        <li>
          <a href="/#pricing">Pricing</a>
        </li>
        <li>
          <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
        </li>
        <li>
          <Link to="/data-processing-agreement">Data Processing Agreement</Link>
        </li>
        <li>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;